<template>
  <div>
    <div v-responsive.lg.xl>
      <desktop
        v-model="login"
        :error="error"
        :processing="processing"
        @do_auth="do_auth"
        :username_field="username_field"
        :logo="logo"
      />
    </div>
    <div v-responsive.md>
      <tablet
        v-model="login"
        :error="error"
        :processing="processing"
        @do_auth="do_auth"
        :username_field="username_field"
        :logo="logo"
      />
    </div>
    <div v-responsive.sm.xs>
      <smartphone
        v-model="login"
        :error="error"
        :processing="processing"
        @do_auth="do_auth"
        :username_field="username_field"
        :logo="logo"
      />
    </div>
  </div>
</template>

<script>
// import "../assets/auth/vendor/bootstrap/css/bootstrap.min.css";
import "../../../assets/auth/css/util.css";
import "../../../assets/auth/css/main.css";
import sha1 from "js-sha1";
import { local_api, api_host } from "../../../utils";

import Desktop from "./login/Desktop.vue";
import Tablet from "./login/Tablet.vue";
import Smartphone from "./login/Smartphone.vue";

export default {
  name: "StudentPortalPublicLogin",
  components: { Desktop, Tablet, Smartphone },
  data() {
    return {
      login: {
        username: "",
        password: "",
      },
      error: "",
      processing: false,
      username_field: this.$t("username"),
      logo: "images/backgrounds/Modul-12.png",
      api_host: api_host,
    };
  },
  mounted() {
    let vm = this;
    if (process.env.NODE_ENV == "development") {
      this.login.username = "ki";
      this.login.password = "ke";
    }
    vm.load_configuration();
    // let sessionExists = this.$session.exists();
    // console.log(this.$session);
    // if (sessionExists) this.$router.replace({ name: "Home" });
  },
  methods: {
    do_auth() {
      let vm = this;
      this.processing = true;
      local_api(this, "post", "/student_portal/auth/do-auth", {
        u: this.login.username,
        p: sha1(this.login.password),
      })
        .then(function (response) {
          if (!response) vm.error = vm.$t("invalid authentication");
          else {
            vm.$emit("switch_nav", { type: "student", data: response.student });
            vm.$session.start();
            vm.$session.set("login_type", "student_portal");
            vm.$session.set("token", response.token);
            vm.$session.set("portal_user", response.student);
            vm.$router.replace({ name: "StudentPortalPublicHome" });
          }
        })
        .catch(function (err) {
          vm.error = err;
        })
        .finally(() => {
          this.processing = false;
        });
    },
    load_configuration() {
      let vm = this;
      local_api(this, "post", "/student_portal/auth/do-get-configuration", {})
        .then(function (conf) {
          if (conf && conf.username_field)
            vm.username_field = conf.username_field;
          if (conf && conf.logo) vm.logo = api_host + "/" + conf.logo;
        })
        .catch(function (err) {
          vm.error = err;
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
  created() {
    this.$emit("hide_nav");
  },
};
</script>

<style>
.wrap-login100 {
  padding: 0;
}
</style>
